import EventManager from '../eventManager/EventManager'
import { Device } from '../helpers'
import MetricsTracker from '../metrics/MetricsTracker'
import WebModel from '../models/WebModel'

export default class SafeFrames {
  private bidsByAdId = {}

  constructor(
    readonly metricsTracker: MetricsTracker,
    readonly model: WebModel,
    pbjs = window.pbjs
  ) {
    if (Device.isMobileOrTablet) {
      this.listenAdRequestFromCreative()

      pbjs.onEvent(EventManager.events.bidResponse, (bid) => {
        this.bidsByAdId[bid.adId] = bid
      })
    }
  }

  private sendAdToCreative(ev): void {
    const key = ev.message ? 'message' : 'data'
    let data
    try {
      data = JSON.parse(ev[key])
    } catch (e) {
      // No ad found.
      data = {}
    }

    if (data.message === 'request ad' && data.adId) {
      const adObject = this.bidsByAdId[data.adId]
      const ad = adObject.ad
      const adUrl = adObject.adUrl
      const message = JSON.stringify({
        message: `send ad ${data.adId}`,
        ad,
        adUrl
      })
      ev.source.postMessage(message, '*')

      this.metricsTracker.record(EventManager.events.bidWon, adObject)
    }
  }

  private listenAdRequestFromCreative(): void {
    addEventListener('message', this.sendAdToCreative.bind(this), false)
  }
}
